module.exports = __webpack_public_path__ + "img/tern.54662f60.svg";